/* eslint-disable camelcase */

import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'translations';
export default function RichTextProductSpecs({ title_key, html, notes }) {
    return (
        <div className="product-specs--richtext">
            <h2 className="product-specs--title"><Trans path={ title_key }/></h2>
            <div dangerouslySetInnerHTML={{ __html: html }}></div>
            { notes ? <small className="product-specs--notes">{notes}</small> : null }
        </div>
    );
}


RichTextProductSpecs.propTypes = {
    html: PropTypes.string.isRequired,
    title_key: PropTypes.string.isRequired,
    notes: PropTypes.string,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/product-specs/richtext/index.js